import { virtualDir } from "#skyward_global";
import { clearValue, disable, enable, setValue } from "./skyward.ui.controls";
import { registerEvents } from "./skyward.ui.events";
import { JQueryInput, Skyward } from "./types";

const classNames =
{
    electronicSignatureAgreeCheckbox: '.electronicSignatureAgreeCheckbox',
    electronicsignature: '.electronicsignature',
    validationList: '.validationList',
    electronicSignatureSignedBy: '.electronicSignatureSignedBy',
    electronicSignatureDateSigned: '.electronicSignatureDateSigned',
    electronicSignatureToggledByCurrentUser: '.electronicSignatureToggledByCurrentUser'
};

const fieldSetConstants =
{
    systemDateTime: 'SkySys/ConfigSystem/GetSystemDateTime',
    post: 'POST',
    errorControl: 'error-control',
    checked: 'checked',
    change: 'change'
};

const events =
{
    registerElectronicSignatureAgreeCheckboxEvent,
    selectErrorListForElectronicSignatureMessageValidation
};

registerEvents("electronicSignature", events);

export function selectErrorListForElectronicSignatureMessageValidation(selectorElement: JQueryInput)
{
    $(selectorElement).each(function () 
    {
        const errorList = $(this);
        errorList.remove();
    });
}

export function registerElectronicSignatureAgreeCheckboxEvent(selectorElement: JQueryInput)
{
    $(selectorElement).on(fieldSetConstants.change, function ()
    {
        const esContainer = $(this).closest(classNames.electronicsignature);
        electronicSignatureAgreeCheckboxChanged(esContainer);
    });
}

function electronicSignatureAgreeCheckboxChanged(esContainer: JQuery<HTMLElement>)
{
    const checkbox = esContainer.find(classNames.electronicSignatureAgreeCheckbox);
    const signedByTextbox = esContainer.find(classNames.electronicSignatureSignedBy);
    const dateSignedTextbox = esContainer.find(classNames.electronicSignatureDateSigned);
    const signedByUserIdValue = esContainer.find(classNames.electronicSignatureToggledByCurrentUser);
    setValue(signedByUserIdValue, true);

    const isChecked = checkbox.prop(fieldSetConstants.checked);
    if (isChecked) 
    {
        disable(checkbox);

        $.ajax(
        {
            url: virtualDir + fieldSetConstants.systemDateTime,
            type: fieldSetConstants.post,
                success: function (data) 
                {
                setValue(signedByTextbox, esContainer.data().userName);
                setValue(dateSignedTextbox, data.systime);
            },
            complete: function () 
            {
                enable(checkbox);
                checkbox.trigger("focus");
            }
        });
    }
    else 
    {
        clearValue(signedByTextbox);
        clearValue(dateSignedTextbox);
        dateSignedTextbox.removeClass(fieldSetConstants.errorControl).removeAttr("aria-invalid");
    }
}
